/**
 * Module-scope flag coordinating section-tab scroll behaviour with the
 * `RouteScrollTop` override. Set to `true` by `SectionTabs.handleTabClick`
 * so that:
 *
 *   - `RouteScrollTop` skips its scroll-to-top override (the tab handler
 *     wants to land flush below the sticky header instead).
 *   - `SectionTabs`' own segment-change `useEffect` knows the in-flight
 *     navigation came from a tab click, and re-issues the flush scroll
 *     after the new segment commits — without firing for unrelated
 *     intra-section navigations (e.g. clicking the site-header `/water`
 *     link from `/water/demand`, which would otherwise be misread as a
 *     tab change and silently drag the reader partway down the page).
 *
 * Reset to `false` by `SectionTabs` once it has consumed the click. A
 * plain object beats a React context here because both consumers live in
 * the same section layout and never need to subscribe to changes — they
 * just read the flag during their own effect runs.
 */
export const sectionScrollState = { tabClicked: false };
